var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecommend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.375H1.125C0.95924 7.375 0.800269 7.44085 0.683058 7.55806C0.565848 7.67527 0.5 7.83424 0.5 8L0.5 14.875C0.5 15.0408 0.565848 15.1997 0.683058 15.3169C0.800269 15.4342 0.95924 15.5 1.125 15.5H3V7.375Z",
    fill: "#CED4DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5869 7C14.3522 6.72567 14.061 6.50541 13.7331 6.35436C13.4052 6.20331 13.0485 6.12507 12.6875 6.125H8.625V3C8.625 1.62125 8.12875 0.5 6.75 0.5C6.61286 0.499972 6.47951 0.545053 6.37052 0.628293C6.26153 0.711533 6.18294 0.828311 6.14687 0.960625L4.25 7.375V15.5H12.0163C12.6142 15.5028 13.1932 15.29 13.6471 14.9007C14.1009 14.5113 14.3993 13.9714 14.4875 13.38L15.16 9.005C15.2144 8.64924 15.1914 8.28593 15.0925 7.93989C14.9936 7.59385 14.8211 7.27325 14.5869 7Z",
    fill: "#CED4DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommend);
export default __webpack_public_path__ + "static/media/recommend.edb430436679eddf4bcc343cbabb5231.svg";
export { ForwardRef as ReactComponent };